import React from "react";
import "./SeeMore.scss";

import Benefits_1 from "../../../assets/images/Benefits_1.png";
import Benefits_2 from "../../../assets/images/Benefits_2.png";
import Benefits_3 from "../../../assets/images/Benefits_3.png";
import Benefits_4 from "../../../assets/images/Benefits_4.png";
import Benefits_5 from "../../../assets/images/Benefits_5.png";
import Benefits_6 from "../../../assets/images/Benefits_6.png";

import BenefitCard from "../../NewHome/Benefits/BenefitCard/BenefitCard";

const SeeMore = () => {
  return (
    <div className="Seemore-Benefits-main-container">
      <div className="Benefits-container">
        <h3>Benefits</h3>
        <h5 className="pt-2">
          Unveiling the Power of Data Analytics in Brand Comparison Websites
        </h5>
      </div>
      <div className="benefits-inner-container">
        <BenefitCard
          img={Benefits_1}
          heading="Informed Consumer Decisions"
          para="Nullam sollicitudin congue erat, nec posuere risus porta laoreet. Praesent quis lobortis purus. In dapibus libero eget libero iaculis convallis. Aliquam vulputate, nibh blandit dapibus imperdiet, est risus tincidunt tellus, sit amet mattis sapien augue bibendum velit. Phasellus accumsan, leo sit amet faucibus tincidunt, tortor."
        />
        <BenefitCard
          img={Benefits_2}
          heading="Market Trends and Insights"
          para="Vestibulum sollicitudin nisl erat, ut ultricies enim maximus non. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec et volutpat velit. Nulla nisl libero, sodales eu nisi eget, gravida congue arcu."
        />
        <BenefitCard
          img={Benefits_3}
          heading="Improved User Engagement"
          para="In porta vitae elit nec volutpat. Aliquam congue semper sapien vel congue. Phasellus a consequat lectus, gravida vehicula nisi. Praesent purus lorem, malesuada vitae mi sit amet, bibendum tristique ipsum. Aliquam porttitor augue mauris, sed pharetra dolor scelerisque a. Nunc sed felis ante. Cras molestie sed nisi sit amet maximus. "
        />

        <BenefitCard
          img={Benefits_4}
          heading="Real-time Updates"
          para="Phasellus pulvinar vitae ligula quis ornare. Curabitur tortor nunc, viverra in consectetur quis, tincidunt sed augue. Aenean erat mi, scelerisque et semper in, efficitur in lorem. Aenean viverra leo vel semper bibendum. Vivamus eu purus est. "
        />
        <BenefitCard
          img={Benefits_5}
          heading="Enhanced SEO Performance"
          para="Aenean viverra leo vel semper bibendum. Vivamus eu purus est. Vivamus pellentesque sed mi et sagittis. Sed sed erat non elit sodales venenatis. Ut ipsum mi, vestibulum nec ex vel, mollis tempor nunc. Praesent id pellentesque arcu. Proin mollis enim dolor, aliquet euismod ipsum gravida ut. Aenean a sem lacus. "
        />
        <BenefitCard
          img={Benefits_6}
          heading="User Retention Strategies"
          para="Pellentesque blandit finibus magna, ut mollis diam egestas ac. Nam varius dolor nibh, et sagittis dui vestibulum sit amet. Fusce eu bibendum massa, sit amet ultricies nunc. Duis placerat consectetur tortor quis tempus. "
        />
      </div>
    </div>
  );
};

export default SeeMore;
